class DateFormats {
    static simpleDate: string = "yyyyMMddHHmmss"
}

export default DateFormats